#import "../../../../../people-iq/graphql/fragments/mcfx-viq-contact-fragment.graphql"

query GetIqContactsForAccount($accountId: ID!) {
    account(id: $accountId) {
        peopleIqContacts {
            totalCount
            edges {
                node {
                    ...McfxViqContactFragment
                }
            }
        }
    }
}
